module.exports = __webpack_public_path__ + "img/choose-up-Up Social Trusou Cta.3e36a1ac.png";